module.exports = __webpack_public_path__ + "static/img/xjsc.f30a271.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xjsc.jpg
// module id = Ucfw
// module chunks = 4